import { atom } from "recoil"
import { Terms } from "src/types/maintenanceUpdate/Terms"

export const newTermsState = atom<Terms | undefined>({
  key: "atoms/updateApp/newTermsState",
  default: undefined,
})
